export default __webpack_public_path__ + "static/media/no_learning_targets.46ffeb26.svg";